import { WhiteLabelConfig } from '../types';

/**
 * Updates CSS custom properties (variables) on the document root
 * to apply white label branding colors throughout the app
 */
export const updateCSSVariables = (config: WhiteLabelConfig) => {
  const root = document.documentElement;

  // Update primary brand color variables
  root.style.setProperty('--primary-color', config.brand_background_color);
  root.style.setProperty('--primary-500', config.brand_background_color);
  root.style.setProperty('--wsr-color-10', config.brand_background_color);
  root.style.setProperty('--wsr-color-30', config.brand_background_color);
  root.style.setProperty('--brand-background-color', config.brand_background_color);

  // Calculate secondary color as 2x lighter (mix 30% brand color with 70% white)
  const secondaryColor = `color-mix(in srgb, ${config.brand_background_color} 15%, white 70%)`;
  root.style.setProperty('--brand-secondary-color', secondaryColor);

  // Update text color
  root.style.setProperty('--brand-text-color', config.brand_text_color);

  // Update PrimeReact button colors (for components that use inline styles)
  const style = document.createElement('style');
  style.id = 'whitelabel-overrides';

  // Remove existing override if present
  const existingStyle = document.getElementById('whitelabel-overrides');
  if (existingStyle) {
    existingStyle.remove();
  }

  style.innerHTML = `
    :root {
      --primary-color: ${config.brand_background_color} !important;
      --primary-500: ${config.brand_background_color} !important;
      --wsr-color-10: ${config.brand_background_color};
      --wsr-color-30: ${config.brand_background_color};
      --brand-background-color: ${config.brand_background_color};
      --brand-secondary-color: ${secondaryColor};
      --brand-text-color: ${config.brand_text_color};
    }

    // .p-button:not(.p-button-icon-only):not(.p-button-link) {
    //   background-color: ${config.brand_background_color} !important;
    //   border-color: ${config.brand_background_color} !important;
    // }

    // .p-button:not(.p-button-icon-only):not(.p-button-link):hover {
    //   background-color: ${config.brand_background_color} !important;
    //   border-color: ${config.brand_background_color} !important;
    //   filter: brightness(1.1);
    // }

    .p-inputswitch:not(.p-disabled):has(.p-inputswitch-input:hover).p-highlight .p-inputswitch-slider {
      background: ${config.brand_background_color} !important;
    }

    .p-radiobutton.p-highlight .p-radiobutton-box {
      background: ${config.brand_background_color} !important;
      border-color: ${config.brand_background_color} !important;
    }

    .p-inputswitch.p-highlight .p-inputswitch-slider {
      background: ${config.brand_background_color} !important;
    }

    .p-datepicker-trigger.p-button {
      background: ${config.brand_background_color} !important;
      border-color: ${config.brand_background_color} !important;
    }

    ::-webkit-scrollbar-thumb {
      background: ${config.brand_background_color}40 !important;
      border-radius: 12px;
    }

    .p-checkbox.p-highlight .p-checkbox-box {
      background: ${config.brand_background_color} !important;
      border-color: ${config.brand_background_color} !important;
    }
  `;

  document.head.appendChild(style);
};

/**
 * Updates the favicon dynamically based on white label config
 */
export const updateFavicon = (logoUrl: string) => {
  const link: HTMLLinkElement =
    document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'icon';
  link.href = logoUrl;
  document.getElementsByTagName('head')[0].appendChild(link);
};

/**
 * Updates the document title based on white label config
 */
export const updatePageTitle = (siteName: string) => {
  document.title = `${siteName} - Dashboard`;
};
